import { Button } from "@mui/material";

import Proof from "../../../components/details/Proof";
import Body from "../../../components/theme/Body";
import Heading from "../../../components/theme/Heading";
import { Step } from "../show";

import PaymentStep from "./PaymentStep";

const ProofStep: Step = ({ details, setStep }) => {
  const {
    demonstrant_name,
    from,
    proof_content_type,
    proof_url,
    sponsor_name,
    to,
  } = details;

  return (
    <>
      <Heading marginBottom="0.5em" variant="h1">
        Hoi {sponsor_name},
      </Heading>
      <Body marginBottom="1em" maxWidth={800}>
        Nogmaals bedankt dat je de reiskosten van {from} naar {to} wil
        vergoeden! Hieronder vind je het bewijs van deelname van{" "}
        {demonstrant_name}.
      </Body>
      <Proof contentType={proof_content_type} url={proof_url} />
      <Body marginBottom="1em" maxWidth={800}>
        Klik op volgende om het geld over te maken.
      </Body>
      <Button
        sx={{ marginTop: "1em" }}
        type="button"
        variant="contained"
        onClick={() => setStep(PaymentStep)}
      >
        Volgende
      </Button>
    </>
  );
};

export default ProofStep;
